<template>
  <button
    type="button"
    class="form-cancel-button inline-flex h-11 items-center justify-center rounded-full px-4 text-sm font-semibold text-zinc-600 transition hover:text-zinc-900 disabled:cursor-not-allowed disabled:opacity-60 dark:text-zinc-300 dark:hover:text-white"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <slot>
      <span class="md:hidden">{{ __('Dismiss') }}</span>
      <span class="hidden md:inline">{{ __('Cancel') }}</span>
    </slot>
  </button>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
